<!-- <div class="wl-logo"> -->
<p-progressSpinner class="flex justify-content-center" *ngIf="paramChave && loadingEmpresa"></p-progressSpinner>
<img alt="Card" [style]="'width: ' + width + ';'" [src]="'/assets/login/logo-text-right.png'" *ngIf="!loadingEmpresa && type == 'logo'" />
<img alt="Card" [style]="'width: ' + width + ';'" [src]="'/assets/login/logo-text-bottom.png'" *ngIf="!loadingEmpresa && type == 'logo-text'" />
<!-- </div> -->